import { keyBy, map } from 'lodash';
export const NOTIFICATION = {
    name: 'Notification',
    value: 'NOTIFICATION',
    route: 'notification',
};
export const EMAIL = {
    name: 'Email',
    value: 'EMAIL',
    route: 'email',
};
export const LOG = {
    name: 'Communication Log',
    value: 'LOG',
    route: 'log',
};
const Basic = [NOTIFICATION, EMAIL, LOG];
const BasicByValue = keyBy(Basic, 'value');
const itemId = ({ value }) => value;
const DefaultValue = map(Basic, itemId);
export default {
    Basic,
    BasicByValue,
    DefaultValue,
    itemId,
};
